// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","sectionHeader":"Footer_sectionHeader__1RM8C","mission":"Footer_mission__2bC4d"};